"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8073],{

/***/ 62145:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ Breadcrumb_Breadcrumb)
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/Breadcrumb.style.ts


const BreadcrumbNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbNav",
  componentId: "hea2ec-0"
})(["width:100%;"]);
const BreadcrumbContainer = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbContainer",
  componentId: "hea2ec-1"
})(["display:flex;align-items:center;list-style:none;padding:0 20px;background:transparent;@media ", "{padding:0 20px;}"], src.deviceType.mobile);
const BreadcrumbItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbItem",
  componentId: "hea2ec-2"
})(["color:#000;font-size:14px;font-weight:400;", " @media ", "{font-size:12px;}"], props => props.isActive && `
    font-weight: 500;
  `, src.deviceType.mobile);
const BreadcrumbLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbLink",
  componentId: "hea2ec-3"
})(["color:#000;text-decoration:none;cursor:pointer;&:hover{text-decoration:underline;}&:visited{color:#000;}"]);
const BreadcrumbSeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbSeparator",
  componentId: "hea2ec-4"
})(["color:#000;margin:0 8px;font-size:14px;user-select:none;@media ", "{margin:0 6px;font-size:12px;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/Breadcrumb.tsx






const Breadcrumb = ({
  className,
  hostname: propHostname
}) => {
  const router = (0,next_router.useRouter)(); // Get current path and hostname

  const currentPath = router.asPath; // Remove query parameters to get clean pathname

  const pathname = currentPath.split("?")[0];
  const hostname = propHostname || ( true ? window.location.hostname : 0);

  const generateBreadcrumbs = () => {
    const breadcrumbs = []; // Always add Home as first breadcrumb

    breadcrumbs.push({
      label: "Home",
      href: `https://${hostname}/`,
      isActive: false
    }); // Check if we're on travel insurance page

    if (pathname.includes("/travel-insurance")) {
      // Check if there's a country in the path
      const countryMatch = pathname.match(/\/travel-insurance\/([^/?]+)/);
      const isOnCountryPage = countryMatch && countryMatch[1];
      const isOnTravelInsurancePage = pathname === "/travel-insurance" || pathname === "/travel-insurance/";
      breadcrumbs.push({
        label: "Travel Insurance",
        href: isOnTravelInsurancePage ? null : `https://${hostname}/travel-insurance/`,
        // No link if already on travel insurance page
        isActive: isOnTravelInsurancePage // Active only if on main travel insurance page

      }); // Add country breadcrumb if on country page

      if (isOnCountryPage) {
        const countrySlug = countryMatch[1]; // Convert slug to readable country name (capitalize first letter)

        const countryName = countrySlug.charAt(0).toUpperCase() + countrySlug.slice(1);
        breadcrumbs.push({
          label: countryName,
          href: null,
          // No link for current page
          isActive: true
        });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null; // Don't show breadcrumb if only home exists
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbNav, {
    "aria-label": "Breadcrumb",
    className: className,
    "data-test-id": "Breadcrumb-BreadcrumbNav",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbContainer, {
      "data-test-id": "Breadcrumb-BreadcrumbContainer",
      children: breadcrumbs.map((breadcrumb, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbItem, {
          isActive: breadcrumb.isActive,
          "aria-current": breadcrumb.isActive ? "page" : undefined,
          "data-test-id": "Breadcrumb-BreadcrumbItem",
          children: breadcrumb.href ? /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbLink, {
            href: breadcrumb.href,
            onClick: e => {
              e.preventDefault();

              if (breadcrumb.href) {
                window.location.href = breadcrumb.href;
              }
            },
            "data-test-id": "Breadcrumb-BreadcrumbLink",
            children: breadcrumb.label
          }) : breadcrumb.label
        }), index < breadcrumbs.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbSeparator, {
          "aria-hidden": "true",
          "data-test-id": "Breadcrumb-BreadcrumbSeparator",
          children: ">"
        })]
      }, index))
    })
  });
};

/* harmony default export */ const Breadcrumb_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/index.tsx


/***/ }),

/***/ 75767:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ClaimYourInsurance_ClaimYourInsurance)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimYourInsurance.style.ts




const ClaimYourInsuranceStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimYourInsuranceStyle",
  componentId: "sc-1iy9j2p-0"
})(["background:#f6f6f6;width:100%;padding:100px 0;@media ", "{padding:48px 16px;", "{> ", "{overflow-y:auto;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;-webkit-overflow-scrolling:touch;}}}"], isomorphic_utils_src.deviceType.mobile, src/* InnerContentWrap */.IY, components/* FlexCompStyle */.lL);
const ClaimStructureStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimStructureStyle",
  componentId: "sc-1iy9j2p-1"
})(["background:#ffffff;border-radius:18.9111px;padding:30px 20px;display:flex;flex-direction:column;gap:16px;width:226px;position:relative;flex-shrink:0;> img{flex-shrink:0;position:absolute;right:-34%;top:40%;}@media ", "{padding:16px;width:180px;> img{right:-21%;}}"], isomorphic_utils_src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimStructure.tsx









const ClaimStructure = ({
  claimIndex,
  claimInfo,
  showSpiral
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ClaimStructureStyle, {
    "data-test-id": "ClaimStructure-ClaimStructureStyle",
    children: [context === isomorphic_utils_src.PARTNER.MMT ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H2Tag",
      children: claimIndex
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3Tag */.AI, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H3Tag",
      children: claimIndex
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
      "data-test-id": "ClaimStructure-SpanTag",
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RichText */.Ho, {
        value: claimInfo,
        "data-test-id": "ClaimStructure-RichText"
      })]
    }), !showSpiral && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
      width: device == "lg" ? "57px" : "24px",
      height: device == "lg" ? "57px" : "24px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/grey_Spiral_de40650b4c.svg",
      "data-test-id": "ClaimStructure-ImageComponent"
    })]
  });
};

/* harmony default export */ const ClaimYourInsurance_ClaimStructure = (ClaimStructure);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimYourInsurance.tsx










const ClaimYourInsurance = ({
  data,
  title,
  info
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsuranceStyle, {
    "data-test-id": "ClaimYourInsurance-ClaimYourInsuranceStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(src/* InnerContentWrap */.IY, {
      "data-test-id": "ClaimYourInsurance-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          color: Global/* theme.greenText */.rS.greenText,
          margin: "0 0 86px",
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
          color: Global/* theme.greenText5 */.rS.greenText5,
          margin: "0 0 20px",
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? "100px" : "48px",
        padding: "0 0 20px 0",
        "data-test-id": "ClaimYourInsurance-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsurance_ClaimStructure, {
              claimInfo: item.claimInfo,
              claimIndex: item.claimIndex,
              showSpiral: index == data.length - 1,
              "data-test-id": `ClaimYourInsurance-ClaimStructure-${index}`
            }, index)
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const ClaimYourInsurance_ClaimYourInsurance = (ClaimYourInsurance);

/***/ }),

/***/ 69452:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ DescriptionModal_DescriptionModal)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionModalDweb.style.tsx



const modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1g04rko-0"
})(["position:fixed;width:", ";height:fit-content;max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", components/* SectionDividersStyle */.$f, components/* TMInputWrap */.dd, src.deviceType.mobile, modalAnim, components/* TMInputWrap */.dd);
const CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalHeader",
  componentId: "sc-1g04rko-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;gap:10px;white-space:nowrap;overflow:hidden;align-items:center;justify-content:space-between;text-overflow:ellipsis;width:100%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], components/* H5TagStyle */.Wl, p => p.nonClipHeading && `
     ${components/* H5TagStyle */.Wl} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, src.deviceType.mobile);
const CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CrossIconWrap",
  componentId: "sc-1g04rko-2"
})(["flex-shrink:0;cursor:pointer;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionModalDweb.tsx






const RegionModalDweb = ({
  children,
  customTitle,
  handleClick,
  customWidth,
  nonClipHeading
}) => {
  (0,react.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(() => {
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ReactPortalComp */.hK, {
    "data-test-id": "RegionModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customWidth: customWidth,
      "data-test-id": "RegionModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionModalDweb-CommonModalHeader",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            "data-test-id": "RegionModalDweb-H5Tag",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "28px",
              height: "28px",
              src: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_47_6c7992dd19.svg",
              "data-test-id": "RegionModalDweb-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
              onClick: handleClick,
              "data-test-id": "RegionModalDweb-CrossIconWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                width: "28px",
                height: "28px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
                "data-test-id": "RegionModalDweb-ImageComponent"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "xlarge",
            fontWeight: "black",
            "data-test-id": "RegionModalDweb-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customTitle,
              "data-test-id": "RegionModalDweb-FormattedText"
            })
          })]
        })
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* BackDropComp */.YP, {
      onClose: handleClick,
      "data-test-id": "RegionModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ const RegionModalDweb_RegionModalDweb = (RegionModalDweb);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DescriptionModal/DescriptionModal.style.tsx

const PopularDescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DescriptionModalstyle__PopularDescriptionWrap",
  componentId: "sc-217pnf-0"
})(["border-radius:4px;padding:12px;background-color:#f6f6f6;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DescriptionModal/DescriptionModal.tsx







const DescriptionModal = ({
  handleDescriptionModal,
  value,
  title
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_RegionModalDweb, {
    handleClick: handleDescriptionModal,
    customTitle: title,
    "data-test-id": "DescriptionModal-RegionModalDweb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PopularDescriptionWrap, {
      "data-test-id": "DescriptionModal-PopularDescriptionWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: "Countries Covered: ",
        baseStyle: {
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "xs"
        },
        "data-test-id": "DescriptionModal-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: value,
        "data-test-id": "DescriptionModal-FormattedText"
      })]
    })
  });
};

/* harmony default export */ const DescriptionModal_DescriptionModal = (DescriptionModal);

/***/ }),

/***/ 10135:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ DomesticTravelDetail_DomesticTrip)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 3 modules
var navigation = __webpack_require__(91908);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DomesticTravelDetail/DomesticTravelDetail.style.ts

const DomesticTripStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__DomesticTripStyle",
  componentId: "uoelnx-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:8px;"]);
const ContainerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__ContainerStyle",
  componentId: "uoelnx-1"
})(["display:flex;", ";", ";"], props => props.flexDirection && `flex-direction: ${props.flexDirection}`, props => props.gap && `gap: ${props.gap}`);
const TagStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__TagStyle",
  componentId: "uoelnx-2"
})(["color:#ffffff;padding:2px 8px 2px 8px;font-weight:600;font-size:10px;align-items:center;border-radius:8px 0px 8px 0px;", ";"], props => `background: linear-gradient(45deg, ${props?.startColor ?? "#00d2ff"} 14.64%, ${props?.endColor ?? "#3a7bd5"} 85.36%)`);
const ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__ArrowButtonWrap",
  componentId: "uoelnx-3"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const BannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__BannerStyle",
  componentId: "uoelnx-4"
})(["display:flex;background:#eaf5ff;padding:8px 15px 12px 16px;border-radius:0px 0px 8px 8px;gap:8px;font-size:14px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DomesticTravelDetail/DomesticTrip.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









const analytics = (0,insurance/* getAnalytics */.I)();

const DomesticTrip = ({
  trips,
  title
}) => {
  (0,react.useEffect)(() => {
    analytics?.trackLandingEvents({
      actionType: "upcoming_domestic_trips_shown"
    }, "pageView");
  }, []);
  const tripData = trips?.[0];

  const handleDomesticClick = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(searchParams.entries());

    const params = _objectSpread(_objectSpread({}, queryParams), {}, {
      isUpcomingTrip: true,
      bookingId: trips?.[0]?.bookingId
    });

    analytics?.trackLandingEvents({
      actionType: "upcoming_domestic_trips_clicked"
    } //"click"
    );
    navigation/* navigationActionsSeo.navigateToTravellerDetails */.Ro.navigateToTravellerDetails(params);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerStyle, {
    flexDirection: "column",
    gap: "10px",
    "data-test-id": "DomesticTrip-ContainerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
      value: title,
      baseStyle: {
        color: Global/* theme.blackText */.rS.blackText
      },
      "data-test-id": "DomesticTrip-FormattedText"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DomesticTripStyle, {
      "data-test-id": "DomesticTrip-DomesticTripStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
        "data-test-id": "DomesticTrip-ContainerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagStyle, {
          startColor: tripData?.tag?.startColor,
          endColor: tripData?.tag?.endColor,
          "data-test-id": "DomesticTrip-TagStyle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: tripData?.tag?.title,
            "data-test-id": "DomesticTrip-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 15px 12px 16px",
        handleClick: handleDomesticClick,
        "data-test-id": "DomesticTrip-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          "data-test-id": "DomesticTrip-SpanTag",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: tripData?.description,
            baseStyle: {
              color: "#4A4A4A",
              fontWeight: "400px",
              fontSize: "12px"
            },
            "data-test-id": "DomesticTrip-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            margin: "7px 0px 0px 0px",
            isCursorPointer: true,
            "data-test-id": "DomesticTrip-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "32px",
              height: "32px",
              margin: "0px 8px 0px 0px",
              src: tripData?.image,
              "data-test-id": "DomesticTrip-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: tripData?.title,
                baseStyle: {
                  color: "#000000",
                  fontWeight: "700",
                  fontSize: "14px"
                },
                "data-test-id": "DomesticTrip-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
                "data-test-id": "DomesticTrip-ContainerStyle",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: tripData?.subtitle,
                  baseStyle: {
                    color: "#4A4A4A",
                    fontWeight: "400",
                    fontSize: "12px"
                  },
                  "data-test-id": "DomesticTrip-FormattedText"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
          "data-test-id": "DomesticTrip-ArrowButtonWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "9px",
            height: "9px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
            "data-test-id": "DomesticTrip-ImageComponent"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BannerStyle, {
        "data-test-id": "DomesticTrip-BannerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: tripData?.banner?.description,
          "data-test-id": "DomesticTrip-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const DomesticTravelDetail_DomesticTrip = (DomesticTrip);

/***/ }),

/***/ 87380:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ExculsiveOffers_ExclusiveOffers)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/ExclusiveOffers.style.ts




const ExclusiveOffersStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__ExclusiveOffersStyle",
  componentId: "sc-11fj0jf-0"
})(["width:100%;background:", ";position:relative;z-index:1;overflow:hidden;display:flex;", "{width:64%;}@media ", "{padding:0 16px;}"], Global/* theme.whiteText */.rS.whiteText, components/* H2TagStyle */.FI, isomorphic_utils_src.deviceType.mobile);
const OfferItemStyle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ExclusiveOffersstyle__OfferItemStyle",
  componentId: "sc-11fj0jf-1"
})(["display:inline-block;background-color:", ";border-radius:8px;width:450px;height:220px;flex-shrink:0;overflow:hidden;@media ", "{width:286px;height:180px;border-radius:16px;", "}"], Global/* theme.whiteText */.rS.whiteText, isomorphic_utils_src.deviceType.mobile, p => p.singleItem && `
      width: calc(100vw - 32px);
      height: calc((100vw - 32px) / 1.5888888888888888);
    `);
const OffersWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__OffersWrap",
  componentId: "sc-11fj0jf-2"
})(["display:flex;align-items:center;gap:20px;overflow-x:auto;margin-left:-16px;padding-left:16px;margin-right:-16px;padding-right:16px;"]);
const SliderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderWrap",
  componentId: "sc-11fj0jf-3"
})(["display:flex;padding-left:7px;padding-top:7px;"]);
const SlidesBtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SlidesBtnWrap",
  componentId: "sc-11fj0jf-4"
})(["box-shadow:0px 1px 7px 0px #00000033;background-color:", ";border-radius:100px;padding:4px 14px;width:72px;height:28px;display:flex;align-items:center;justify-content:space-between;"], Global/* theme.whiteText */.rS.whiteText);
const SliderArrowLeft = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowLeft",
  componentId: "sc-11fj0jf-5"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(135deg);-webkit-transform:rotate(135deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, p => p.disable && `opacity: 0.5;`);
const SliderArrowRight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowRight",
  componentId: "sc-11fj0jf-6"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, p => p.disable && `opacity: 0.5;`);
const SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderContainer",
  componentId: "sc-11fj0jf-7"
})(["overflow:hidden;width:100%;position:relative;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/OfferItem.tsx




const aspectRatio = (/* unused pure expression or super */ null && (286 / 180));

const OfferItem = ({
  cta,
  image_url,
  handleClickOfferItem,
  offerItemLength
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferItemStyle, {
    onClick: handleClickOfferItem,
    href: cta.url,
    rel: "noreferrer",
    target: "_blank",
    singleItem: offerItemLength == 1 && device == "sm",
    "data-test-id": "OfferItem-OfferItemStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
      src: image_url,
      width: "100%",
      height: "100%",
      "data-test-id": "OfferItem-ImageTag"
    })
  });
};

/* harmony default export */ const ExculsiveOffers_OfferItem = (OfferItem);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/ExclusiveOffers.tsx









const analytics = (0,insurance/* getAnalytics */.I)();

const ExclusiveOffers = ({
  data
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: currentSlide,
    1: setCurrentSlide
  } = (0,react.useState)(0);

  const handleNext = () => {
    if (currentSlide < data.items.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  (0,react.useEffect)(() => {
    data.items.forEach((item, index) => {
      const element = document.getElementById(`slide${index}`);
      const observer = new IntersectionObserver(obCallback, {
        threshold: 1
      });
      element && observer.observe(element);

      function obCallback(entries) {
        if (entries[0].isIntersecting) {
          analytics?.trackLandingEvents({
            actionType: `offer_banner${index + 1}_shown`
          } // "click"
          );
          (0,XDMAnalytics.trackComponentView)({
            name: `offer_banner_${index + 1}_shown`,
            type: "offers"
          });
        }
      }
    });
  }, [data.items]);

  const handleClickOfferItem = index => {
    analytics?.trackLandingEvents({
      actionType: `offer_banner${index + 1}_clicked`
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `offer_banner_${index + 1}_clicked`
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExclusiveOffersStyle, {
    "data-test-id": "ExclusiveOffers-ExclusiveOffersStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(src/* InnerContentWrap */.IY, {
      "data-test-id": "ExclusiveOffers-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        margin: "0 0 60px",
        alignItems: "center",
        justifyContent: "space-between",
        "data-test-id": "ExclusiveOffers-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          "data-test-id": "ExclusiveOffers-H2Tag",
          children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: data.title,
            "data-test-id": "ExclusiveOffers-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlidesBtnWrap, {
          "data-test-id": "ExclusiveOffers-SlidesBtnWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowLeft, {
            disable: currentSlide == 0,
            onClick: handlePrev,
            "data-test-id": "ExclusiveOffers-SliderArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowRight, {
            disable: currentSlide == data.items.length - 1,
            onClick: handleNext,
            "data-test-id": "ExclusiveOffers-SliderArrowRight"
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        margin: "0 0 20px",
        "data-test-id": "ExclusiveOffers-H5Tag",
        children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: data.title,
          "data-test-id": "ExclusiveOffers-FormattedText"
        })
      }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(OffersWrap, {
        "data-test-id": "ExclusiveOffers-OffersWrap",
        children: data.items && data.items.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: `slide${index}`,
            "data-test-id": `ExclusiveOffers-${index}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
              handleClickOfferItem: () => handleClickOfferItem(index),
              cta: item.cta,
              image_url: item.image_url,
              offerItemLength: data.items.length,
              "data-test-id": "ExclusiveOffers-OfferItem"
            })
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SliderContainer, {
        "data-test-id": "ExclusiveOffers-SliderContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SliderWrap, {
          style: {
            transform: `translateX(-${currentSlide * 42}%)`,
            transition: "transform 0.5s ease-in-out"
          },
          "data-test-id": "ExclusiveOffers-SliderWrap",
          children: data.items && data.items.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: `slide${index}`,
              style: {
                marginRight: 20
              },
              "data-test-id": `ExclusiveOffers-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
                handleClickOfferItem: () => handleClickOfferItem(index),
                cta: item.cta,
                image_url: item.image_url,
                "data-test-id": "ExclusiveOffers-OfferItem"
              })
            }, index);
          })
        })
      })]
    })
  });
};

/* harmony default export */ const ExculsiveOffers_ExclusiveOffers = (ExclusiveOffers);

/***/ }),

/***/ 30845:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ InsuranceStats_InsuranceStats)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InsuranceStats/InsuranceStats.style.ts


const InsuranceStatsWrap = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsWrap",
  componentId: "sc-1qor9fz-0"
})(["width:100%;@media ", "{padding:0 16px;}"], isomorphic_utils_src.deviceType.mobile);
const InsuranceStatsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsStyle",
  componentId: "sc-1qor9fz-1"
})(["background:#fff;border-radius:16px;padding:40px 80px;display:flex;gap:114px;width:1200px;margin:0 auto;position:relative;z-index:1;display:grid;grid-template-columns:repeat(4,1fr);box-shadow:0px 3px 30px rgba(0,0,0,0.1);", " @media ", "{width:100%;gap:24px;padding:16px;grid-template-columns:repeat(2,1fr);box-shadow:none;", "}"], p => p.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    border-radius: 20px;
    background: #FFF;
    `, isomorphic_utils_src.deviceType.mobile, p => p.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    background: #fff;
    box-shadow:none;
    `);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InsuranceStats/InsuranceStats.tsx







const InsuranceStats = ({
  data
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsWrap, {
    id: "insurance-stats",
    "data-test-id": "InsuranceStats-InsuranceStatsWrap",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsStyle, {
      pageTheme: context ? context : undefined,
      "data-test-id": "InsuranceStats-InsuranceStatsStyle",
      children: data && data.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-test-id": `InsuranceStats-${index}`,
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H4Tag */.j9, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H4Tag",
            children: item.title
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H5Tag",
            children: item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: device == "lg" ? "md" : "xs",
            "data-test-id": "InsuranceStats-ParaTag",
            children: item.info
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ const InsuranceStats_InsuranceStats = (InsuranceStats);

/***/ }),

/***/ 20190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ InterlinkingBlock_InterlinkingBlock)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/InterlinkingBlock.style.ts



const InterlinkingBlockStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InterlinkingBlockstyle__InterlinkingBlockStyle",
  componentId: "sc-18rfz75-0"
})(["background:", ";color:", ";padding:20px 0;width:100%;"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText);
const InterlinkingBlockWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__InterlinkingBlockWrap",
  componentId: "sc-18rfz75-1"
})(["margin:0 auto;max-width:1200px;padding:0 20px;@media screen and ", "{padding:0 16px;}"], src.deviceType.mobile);
const SectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__SectionContainer",
  componentId: "sc-18rfz75-2"
})(["display:flex;flex-direction:column;gap:40px;& > *:last-child{gap:0;}@media screen and ", "{gap:30px;& > *:last-child{gap:0;}}"], src.deviceType.mobile);
const Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__Section",
  componentId: "sc-18rfz75-3"
})(["display:flex;flex-direction:column;"]);
const SectionTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "InterlinkingBlockstyle__SectionTitle",
  componentId: "sc-18rfz75-4"
})(["color:", ";font-size:14px;font-weight:700;margin-bottom:8px;line-height:1.4;text-transform:uppercase;letter-spacing:0.5px;@media screen and ", "{font-size:13px;margin-bottom:6px;}"], Global/* theme.blackText */.rS.blackText, src.deviceType.mobile);
const LinksContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__LinksContainer",
  componentId: "sc-18rfz75-5"
})(["line-height:1.6;text-align:justify;"]);
const LinkItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InterlinkingBlockstyle__LinkItem",
  componentId: "sc-18rfz75-6"
})(["&:not(:last-child):after{content:\", \";color:", ";}"], Global/* theme.blackText */.rS.blackText);
const Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "InterlinkingBlockstyle__Link",
  componentId: "sc-18rfz75-7"
})(["color:", ";text-decoration:none;font-size:13px;font-weight:400;line-height:1.6;transition:color 0.2s ease;&:hover{color:", ";text-decoration:underline;}@media screen and ", "{font-size:12px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.blackText */.rS.blackText || "#007bff", src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/InterlinkingBlock.tsx





const InterlinkingBlock = ({
  interlinkingBlock = []
}) => {
  if (!interlinkingBlock || interlinkingBlock.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(InterlinkingBlockStyle, {
    "data-test-id": "InterlinkingBlock-InterlinkingBlockStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InterlinkingBlockWrap, {
      "data-test-id": "InterlinkingBlock-InterlinkingBlockWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionContainer, {
        "data-test-id": "InterlinkingBlock-SectionContainer",
        children: interlinkingBlock?.map((section, sectionIndex) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          className: `${sectionIndex}`,
          "data-test-id": "InterlinkingBlock-Section",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle, {
            "data-test-id": "InterlinkingBlock-SectionTitle",
            children: section?.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksContainer, {
            "data-test-id": "InterlinkingBlock-LinksContainer",
            children: section?.links?.map((link, linkIndex) => /*#__PURE__*/(0,jsx_runtime.jsx)(LinkItem, {
              "data-test-id": "InterlinkingBlock-LinkItem",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                href: link?.url,
                rel: "noopener noreferrer",
                "data-test-id": "InterlinkingBlock-Link",
                children: link.title
              })
            }, `link-${sectionIndex}-${linkIndex}`))
          })]
        }, `section-${sectionIndex}`))
      })
    })
  });
};

/* harmony default export */ const InterlinkingBlock_InterlinkingBlock = (InterlinkingBlock);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/index.tsx


/***/ }),

/***/ 69004:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingFaq_LandingFaq)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 10 modules
var components = __webpack_require__(98790);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var static_components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFaq/LandingFaq.style.ts



const LandingFaqStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFaqstyle__LandingFaqStyle",
  componentId: "sc-1sfu3od-0"
})(["", " display:flex;background:#fff;flex-direction:column;width:100%;", ""], props => props.margin && `margin: ${props.margin};`, props => props.customFaq && ``);
const LandingFaqTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqTitle",
  componentId: "sc-1sfu3od-1"
})(["font-family:\"Lato\";font-weight:400;font-size:36px;line-height:56px;margin-left:", ";margin-bottom:", ";color:", ";@media screen and ", "{font-weight:500;font-size:24px;line-height:32px;margin-bottom:8px;margin-left:", ";}"], props => props.marginLeft ? props.marginLeft : "0px", props => props.marginBottom ? props.marginBottom : "56px", Global/* theme.blackText */.rS.blackText, utils/* deviceType.mobile */.vO.mobile, props => props.marginLeft ? props.marginLeft : "0px");
const LandingFaqList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFaqstyle__LandingFaqList",
  componentId: "sc-1sfu3od-2"
})(["width:1000px;gap:16px;li{margin-bottom:16px;position:relative;cursor:pointer;}li h3{padding:24px;@media screen and ", "{padding:16px;}}li p{padding:0 24px 24px;}li .faq-content{max-height:0;overflow:hidden;opacity:0;padding:0 24px;}li.open .faq-content{max-height:10000px;opacity:1;padding:0 24px 24px;}li:after{content:\"\";position:absolute;border:solid black;border-width:0 3px 3px 0;display:inline-block;padding:3px;right:24px;top:33px;transition:0.3s ease-in;@media screen and ", "{top:16px;}}li.close:after{transform:rotate(45deg);-webkit-transform:rotate(45deg);}li.open:after{transform:rotate(-135deg);-webkit-transform:rotate(-135deg);}li:hover{background:#ffffff;box-shadow:0px 4px 16px rgba(0,0,0,0.16);border-radius:6px;}li:last-child{margin-bottom:unset;}", " @media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile, props => props.customFaq && `
            width:100%;
            gap:8px;
            margin-bottom: 24px;
            li {
                padding: 12px 16px;
                background: #FFFFFF;
                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
                border-radius: 6px;
            }
            li h3 {
                padding: unset;
            }
            li p {
                padding:unset;
                font-size: 12px;
                line-height: 16px;
                color: #000000;
            }
            li:after {
                border: solid #008CFF;
                border-width: 0 2px 2px 0;
                padding: 4px;
                right: 24px;
                top: 13px;
            }
    `, utils/* deviceType.mobile */.vO.mobile);
const LandingFaqQues = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqQues",
  componentId: "sc-1sfu3od-3"
})(["font-weight:700;font-size:22px;line-height:30px;color:#000;", " @media screen and ", "{font-weight:700;font-size:16px;line-height:20px;}"], props => props.customFaq && `
        font-size: 12px;
        line-height: 16px;
        color: #000000;`, utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFaq/LandingFaq.tsx








const LandingFaq = ({
  customTitle,
  customFaq,
  faq,
  margin
}) => {
  const {
    0: exp,
    1: setExp
  } = (0,react.useState)(-1);
  const device = (0,src/* useBreakpointV2 */.bU)();

  const handleClick = index => {
    exp != index ? setExp(index) : setExp(-1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqStyle, {
    margin: margin,
    customFaq: customFaq,
    "data-test-id": "LandingFaq-LandingFaqStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(src/* InnerContentWrap */.IY, {
      "data-test-id": "LandingFaq-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
        margin: "0 0 24px 0",
        "data-test-id": "LandingFaq-H2Tag",
        children: customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingFaq-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
        margin: "0 0 24px 16px",
        "data-test-id": "LandingFaq-H5Tag",
        children: customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingFaq-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqList, {
        customFaq: customFaq,
        "data-test-id": "LandingFaq-LandingFaqList",
        children: faq.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: `${exp == index ? "open" : "close"}`,
            onClick: () => handleClick(index),
            "data-test-id": `LandingFaq-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqQues, {
              customFaq: customFaq,
              "data-test-id": "LandingFaq-LandingFaqQues",
              children: item.ques && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
                value: item.ques,
                "data-test-id": "LandingFaq-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "faq-content",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
                value: item.info,
                baseStyle: {
                  whiteSpace: "pre-line"
                },
                "data-test-id": "LandingFaq-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const LandingFaq_LandingFaq = (LandingFaq);

/***/ }),

/***/ 81086:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingFooter_LandingFooter)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFooter/LandingFooter.style.ts



const LandingFooterStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFooterstyle__LandingFooterStyle",
  componentId: "sc-14d61ct-0"
})(["background:", ";color:", ";padding-top:32px;padding-bottom:64px;width:100%;@media screen and ", "{padding-bottom:22px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.whiteText */.rS.whiteText, src.deviceType.mobile);
const ChevronContainerIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingFooterstyle__ChevronContainerIcon",
  componentId: "sc-14d61ct-1"
})(["transform:", ";"], props => props.isInvert ? "rotate(180deg)" : "rotate(0deg)");
const LinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__LinksContainer",
  componentId: "sc-14d61ct-2"
})(["margin-bottom:", ";& > li:not(:last-child){margin-bottom:24px;}@media screen and ", "{margin-bottom:40px;& > li{padding:16px;border-bottom:1px ", " solid;}& > li:not(:last-child){margin-bottom:unset;}}"], p => p.isCopyrightText ? "100px" : "0", src.deviceType.mobile, Global/* theme.greyText */.rS.greyText);
const FooterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__FooterSection",
  componentId: "sc-14d61ct-3"
})(["width:964px;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
const InnerLinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__InnerLinksContainer",
  componentId: "sc-14d61ct-4"
})(["display:flex;margin-top:10px;flex-wrap:wrap;& > li{position:relative;color:white;font-size:12px;line-height:16px;}& > li::after{content:\"\u2022\";margin-left:4px;margin-right:4px;}& > li:last-child:after{content:\"\";}"]);
const LandingFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterWrap",
  componentId: "sc-14d61ct-5"
})(["margin:0 auto;width:1200px;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx + 8 modules
var icons = __webpack_require__(51046);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFooter/LandingFooter.tsx








const LandingFooter = ({
  footerData,
  followUsText = "FOLLOW US",
  downloadText = "DOWNLOAD",
  countryText = "Country",
  locationText = "INDIA",
  mmtText = "MAKEMYTRIP PVT. LTD.",
  playStoreImgURI,
  appStoreImgURI,
  linkedInImgURI,
  facebookImgURI,
  twitterImgURI,
  downIcon,
  footerHeartIcon,
  footerHeading,
  footerCopyrightData
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: activeIdx,
    1: setActiveIdx
  } = (0,react.useState)(-1);
  let footerTextOne = "";
  let headerAlt = "";
  let headerImg = "";
  let footerTextTwo = "";
  const regex = /^(.*?)!\[(.*?)\]\((.*?)\)(.*?)$/;
  const match = footerHeading?.value?.match(regex);

  if (match) {
    footerTextOne = match[1].trim();
    headerAlt = match[2].trim();
    headerImg = match[3].trim();
    footerTextTwo = match[4].trim();
  }

  const copyrightText = footerCopyrightData?.items?.find(item => item.type === "copyright")?.value;

  const optionsHandler = index => {
    if (activeIdx === index) {
      setActiveIdx(-1);
      return;
    }

    setActiveIdx(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterStyle, {
    "data-test-id": "LandingFooter-LandingFooterStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterWrap, {
      "data-test-id": "LandingFooter-LandingFooterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FooterSection, {
        "data-test-id": "LandingFooter-FooterSection",
        children: [footerHeading && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          alignItems: "center",
          justifyContent: device === "sm" ? "center" : undefined,
          margin: "0px 0px 50px 0px",
          "data-test-id": "LandingFooter-FlexComp",
          children: [footerTextOne && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 8px 4px 0px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextOne
          }), headerImg ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "85px",
            height: "27px",
            src: headerImg,
            alt: headerAlt,
            "data-test-id": "LandingFooter-ImageComponent"
          }) : null, footerTextTwo && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 0px 4px 8px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextTwo
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksContainer, {
          isCopyrightText: !!copyrightText,
          "data-test-id": "LandingFooter-LinksContainer",
          children: footerData?.map((item, idx) => {
            return item?.label && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              onClick: device === "sm" ? () => optionsHandler(idx) : undefined,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                justifyContent: device === "sm" ? "space-between" : undefined,
                gap: "8px",
                alignItems: "center",
                "data-test-id": "LandingFooter-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                  gap: "10px",
                  "data-test-id": "LandingFooter-FlexComp",
                  children: [item?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                    width: "18px",
                    height: "18px",
                    src: item.icon,
                    "data-test-id": "LandingFooter-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
                    color: "white",
                    fontWeight: "black",
                    "data-test-id": "LandingFooter-ParaTag",
                    children: item.label
                  })]
                }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronContainerIcon, {
                  isInvert: activeIdx !== idx,
                  "data-test-id": "LandingFooter-ChevronContainerIcon",
                  children: downIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
                    src: downIcon,
                    "data-test-id": "LandingFooter-ImageTag"
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ChevronUpIcon */.g8, {
                    "data-test-id": "LandingFooter-ChevronUpIcon"
                  })
                })]
              }), device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(point => {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              }) : activeIdx === idx && /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(point => {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              })]
            }, item.id);
          })
        })]
      }), copyrightText && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        flexDirection: device === "sm" ? "column" : undefined,
        justifyContent: "space-between",
        "data-test-id": "LandingFooter-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            textAlign: device === "lg" ? "right" : "center"
          },
          dangerouslySetInnerHTML: {
            __html: copyrightText.replace(/\n/g, "<br />")
          }
        })
      })]
    })
  });
};

/* harmony default export */ const LandingFooter_LandingFooter = (LandingFooter);

/***/ }),

/***/ 37580:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingTestimonials_LandingTestimonials)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx + 8 modules
var icons = __webpack_require__(51046);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingTestimonials/LandingTestimonials.style.ts



const LandingTestimonialsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestimonialsStyle",
  componentId: "sc-1e4zunl-0"
})(["display:flex;background:#fff;flex-direction:column;margin-bottom:137px;width:100%;@media ", "{margin-bottom:40px;}"], isomorphic_utils_src.deviceType.mobile);
const LandingTestTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestTitle",
  componentId: "sc-1e4zunl-1"
})(["font-family:\"Lato\";font-weight:500;font-size:56px;line-height:72px;color:#000000;margin-bottom:34px;display:flex;align-items:center;@media ", "{font-size:24px;line-height:32px;margin-bottom:12px;padding:0px 16px;}"], isomorphic_utils_src.deviceType.mobile);
const TestimonialContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialContent",
  componentId: "sc-1e4zunl-2"
})(["display:flex;margin-bottom:8px;> img{margin-right:17px;border-radius:8px;}"]);
const LandingTest = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTest",
  componentId: "sc-1e4zunl-3"
})(["display:inline-block;img{object-fit:contain;}@media ", "{font-weight:400;color:#4a4a4a;align-items:flex-start;border-radius:10px;position:relative;background:#fff;z-index:1;width:100% !important;flex-direction:column !important;padding:4px 16px;font-size:14px;line-height:20px;}"], isomorphic_utils_src.deviceType.mobile);
const LandingTestWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestWrap",
  componentId: "sc-1e4zunl-4"
})(["display:flex;width:575px;padding:32px 30px;background:#fff;position:relative;z-index:1;border-radius:10px;margin-right:20px;", "{white-space:initial;}@media ", "{width:unset;padding:16px;", "{font-size:14px;line-height:20px;}box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:10px;margin-right:unset;}"], components/* ParaTagStyle */.OG, isomorphic_utils_src.deviceType.mobile, components/* ParaTagStyle */.OG);
const LandingTestImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestImg",
  componentId: "sc-1e4zunl-5"
})(["width:150px;height:250px;flex-shrink:0;position:relative;margin-right:20px;z-index:1;> img{border-radius:20px;}@media ", "{width:84px;height:87px;display:flex;}"], isomorphic_utils_src.deviceType.mobile);
const LandingTextCrd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTextCrd",
  componentId: "sc-1e4zunl-6"
})(["padding:4px 8px 4px 8px;border-radius:19px;font-weight:700;font-size:12px;line-height:11px;color:#fff;position:absolute;bottom:-7px;left:25px;text-transform:uppercase;", " ", " @media ", "{position:static;width:fit-content;}"], p => p.cardType == "travelLoan" && `
    background: linear-gradient(88.44deg, #43e1a8 0.02%, #28beb2 100.01%);
    `, p => p.cardType == "forexCard" && `
    background: linear-gradient(85.23deg, #ff7f3f 0%, #ff3e5e 100%);
    `, isomorphic_utils_src.deviceType.mobile);
const PersonName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__PersonName",
  componentId: "sc-1e4zunl-7"
})(["font-weight:700;font-size:24px;line-height:36px;color:#012136;margin-bottom:2px;display:block;@media ", "{font-size:16px;line-height:20px;font-weight:900;}"], isomorphic_utils_src.deviceType.mobile);
const LandingTestimonials_style_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__Date",
  componentId: "sc-1e4zunl-8"
})(["font-weight:400;font-size:14px;line-height:18px;color:#9b9b9b;@media ", "{font-size:12px;}"], isomorphic_utils_src.deviceType.mobile);
const LandingTestCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestCntnt",
  componentId: "sc-1e4zunl-9"
})(["z-index:1;@media ", "{white-space:initial;}"], isomorphic_utils_src.deviceType.mobile);
const Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__Flex",
  componentId: "sc-1e4zunl-10"
})(["display:flex;width:100%;margin-bottom:8px;"]);
const SlideShowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowContainer",
  componentId: "sc-1e4zunl-11"
})(["margin:0 auto;overflow:hidden;max-width:1200px;@media ", "{max-width:100%;cursor:grab;}"], isomorphic_utils_src.deviceType.mobile);
const SlideShowSLider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowSLider",
  componentId: "sc-1e4zunl-12"
})(["white-space:nowrap;transition:ease 1000ms;"]);
const SlideDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideDots",
  componentId: "sc-1e4zunl-13"
})(["text-align:center;@media ", "{margin-top:12px;}"], isomorphic_utils_src.deviceType.mobile);
const SlideShowDotItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowDotItem",
  componentId: "sc-1e4zunl-14"
})(["background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;", ""], p => p.active && `
        width: 32px;
        height: 12px;
        background: #000000 !important;
        opacity: 1;
        border-radius: 6px;
        `);
const StarRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRating",
  componentId: "sc-1e4zunl-15"
})(["display:flex;gap:8px;", " @media ", "{gap:5px;}"], p => p.starRateFull && `
    position: absolute;
    top: 0;
    `, isomorphic_utils_src.deviceType.mobile);
const StarRatingWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRatingWrap",
  componentId: "sc-1e4zunl-16"
})(["margin-bottom:12px;position:relative;"]);
const TestimonialTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialTag",
  componentId: "sc-1e4zunl-17"
})(["background:rgba(120,198,255,0.2);border:1px solid rgba(120,198,255,0.4);border-radius:8px;padding:2px 12px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingTestimonials/LandingTestimonials.tsx









const LandingTestimonials = ({
  customTitle,
  test
}) => {
  const {
    0: currentIndex,
    1: setCurrentIndex
  } = (0,react.useState)(0);
  const {
    0: length,
    1: setLength
  } = (0,react.useState)(test?.length);
  const {
    0: touchPosition,
    1: setTouchPosition
  } = (0,react.useState)(null);
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: isHovered,
    1: setIsHovered
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setLength(test?.length);
  }, [test]);

  const next = () => {
    if (currentIndex < length - 1) {
      setCurrentIndex(prevState => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prevState => prevState - 1);
    }
  };

  const handleTouchStart = e => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = e => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);

    if (isHovered) {
      resetTimeout();
    }
  };

  const timeoutRef = react.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  react.useEffect(() => {
    resetTimeout();
    timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
    return () => {
      resetTimeout();
      timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
    };
  }, [currentIndex]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    resetTimeout();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    resetTimeout();
    timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestimonialsStyle, {
    "data-test-id": "LandingTestimonials-LandingTestimonialsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(src/* InnerContentWrap */.IY, {
      "data-test-id": "LandingTestimonials-InnerContentWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestTitle, {
        "data-test-id": "LandingTestimonials-LandingTestTitle",
        children: [customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingTestimonials-FormattedText"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
          width: device == "lg" ? "66px" : "32px",
          height: device == "lg" ? "66px" : "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/heart_9289dd4a1d.svg",
          "data-test-id": "LandingTestimonials-ImageComponent"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideShowContainer, {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-test-id": "LandingTestimonials-SlideShowContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowSLider, {
          style: {
            transform: `translateX(-${currentIndex * (device === "lg" ? 50 : 100)}%)`
          },
          "data-test-id": "LandingTestimonials-SlideShowSLider",
          children: test && test.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTest, {
              "data-test-id": `LandingTestimonials-LandingTest-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestWrap, {
                "data-test-id": "LandingTestimonials-LandingTestWrap",
                children: [device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestImg, {
                  "data-test-id": "LandingTestimonials-LandingTestImg",
                  children: [item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                    width: "150",
                    height: "250",
                    alt: "hello",
                    src: item.personImg.src,
                    "data-test-id": "LandingTestimonials-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                    cardType: item.personCrdClass,
                    "data-test-id": "LandingTestimonials-LandingTextCrd",
                    children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.personCard,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestCntnt, {
                  "data-test-id": "LandingTestimonials-LandingTestCntnt",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialContent, {
                    "data-test-id": "LandingTestimonials-TestimonialContent",
                    children: [device !== "lg" && item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      width: "84",
                      height: "87",
                      alt: "",
                      src: item.personImg.src
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
                        "data-test-id": "LandingTestimonials-PersonName",
                        children: item.personName && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                          value: item.personName,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StarRatingWrap, {
                        "data-test-id": "LandingTestimonials-StarRatingWrap",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: 5
                          }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarEmpty */.rj, {
                            height: device !== "lg" ? 16 : 25,
                            width: device !== "lg" ? 16 : 26,
                            "data-test-id": `LandingTestimonials-StarEmpty-${index}`
                          }, index))
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          starRateFull: true,
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: Number(item.personRating)
                          }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarFull */.Um, {
                            height: device !== "lg" ? 16 : 25,
                            width: device !== "lg" ? 16 : 26,
                            "data-test-id": `LandingTestimonials-StarFull-${index}`
                          }, index))
                        })]
                      }), device !== "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                        "data-test-id": "LandingTestimonials-LandingTextCrd",
                        children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                          value: item.personCard,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
                    fontSize: "md",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "LandingTestimonials-ParaTag",
                    children: item.testInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.testInfo,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                })]
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDots, {
          "data-test-id": "LandingTestimonials-SlideDots",
          children: test?.map((_, idx) => /*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowDotItem, {
            active: currentIndex === idx,
            onClick: () => {
              setCurrentIndex(idx);
            },
            "data-test-id": `LandingTestimonials-SlideShowDotItem-${idx}`
          }, idx))
        })]
      })]
    })
  });
};

/* harmony default export */ const LandingTestimonials_LandingTestimonials = (LandingTestimonials);

/***/ }),

/***/ 85662:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PersuasionBanner_PersuasionBannerInsurance)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/PersuasionBanner/PersuasionBanner.style.tsx




const PersuasionBannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionBannerstyle__PersuasionBannerStyle",
  componentId: "szyc0w-0"
})(["", " padding:30px 34px;border-radius:25px;background-image:", ";background-size:contain;background-repeat:no-repeat;display:flex;flex-direction:column;height:400px;gap:20px;em{color:", ";font-weight:700;font-style:normal;}", "{width:100%;}& ul{display:flex;flex-direction:column;gap:16px;}& li{position:relative;padding-left:16px;}& li:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}@media ", "{padding:32px 16px;background-size:cover;border:1px solid #fff;margin-bottom:16px;}", "{margin-bottom:16px;&:last-child{margin-bottom:0;}@media ", "{margin-bottom:8px;}}", "{padding:10px 40px;}"], props => props.margin && `margin: ${props.margin};`, props => `url(${props.bgImage})`, Global/* theme.greenText */.rS.greenText, components/* H3TagStyle */.KO, Global/* theme.darkYellowText */.rS.darkYellowText, isomorphic_utils_src.deviceType.mobile, components/* BulletListItemStyle */.Il, isomorphic_utils_src.deviceType.mobile, components/* LandingButtonStyle */.zm);
const BulletListStyle = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "PersuasionBannerstyle__BulletListStyle",
  componentId: "szyc0w-1"
})(["display:flex;flex-direction:column;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/PersuasionBanner/PersuasionBannerInsurance.tsx






const PersuasionBannerInsurance = ({
  crossSell,
  btnHandler
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();

  if (!crossSell) {
    return null;
  }

  const {
    title,
    background,
    description,
    cta,
    info
  } = crossSell;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PersuasionBannerStyle, {
    bgImage: background?.url,
    "data-test-id": "PersuasionBannerInsurance-PersuasionBannerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3Tag */.AI, {
      "data-test-id": "PersuasionBannerInsurance-H3Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "PersuasionBannerInsurance-FormattedText"
      })
    }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
      gap: "6px",
      "data-test-id": "PersuasionBannerInsurance-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        "data-test-id": "PersuasionBannerInsurance-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: info,
          "data-test-id": "PersuasionBannerInsurance-FormattedText"
        })
      })
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MarkdownText */.rU, {
      value: description,
      "data-test-id": "PersuasionBannerInsurance-MarkdownText"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
      customTitle: cta?.title,
      onClick: btnHandler,
      padding: "0px 40px",
      "data-test-id": "PersuasionBannerInsurance-LandingButton"
    })]
  });
};

/* harmony default export */ const PersuasionBanner_PersuasionBannerInsurance = (PersuasionBannerInsurance);

/***/ }),

/***/ 20381:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SafenSecureTrav_SafenSecureTrav)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTrav.style.ts



const SafenSecureTravStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravStyle",
  componentId: "sc-1t32hx4-0"
})(["width:100%;background:#fff;position:relative;z-index:1;overflow:hidden;", "{width:64%;}@media ", "{padding:0 16px;}"], components/* H2TagStyle */.FI, isomorphic_utils_src.deviceType.mobile);
const SafenSecureTravCrdStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravCrdStyle",
  componentId: "sc-1t32hx4-1"
})(["background:linear-gradient( 128.03deg,rgba(227,247,245,0.36) 2.1%,rgba(230,237,255,0.441706) 49.06%,rgba(214,232,244,0.6) 80.75% ),#fcffff;border-radius:14px;padding:24px;flex:1;position:relative;display:flex;flex-direction:column;gap:24px;> img{position:absolute;right:30px;bottom:24px;}@media ", "{gap:12px;}"], isomorphic_utils_src.deviceType.mobile);
const FeatList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "SafenSecureTravstyle__FeatList",
  componentId: "sc-1t32hx4-2"
})(["display:flex;flex-direction:", ";gap:", ";max-width:80%;li{position:relative;padding-left:14px;}li:after{content:\"\";position:absolute;background:#000000;border-radius:2px;width:4px;height:14px;top:6px;left:0;}@media ", "{margin-bottom:12px;flex-direction:column;gap:16px;}"], p => p.cardQuantity === 1 ? "row" : "column", p => p.cardQuantity === 1 ? "50px" : "16px", isomorphic_utils_src.deviceType.mobile);
const SafenSecureBgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureBgWrap",
  componentId: "sc-1t32hx4-3"
})(["position:absolute;top:17px;right:-122px;width:100%;z-index:-1;height:558px;img{width:100%;height:558px;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTravCrd.tsx






const SafenSecureTravCrd = ({
  title,
  featList,
  cardImg,
  poweredBy,
  cardQuantity
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravCrdStyle, {
    "data-test-id": "SafenSecureTravCrd-SafenSecureTravCrdStyle",
    children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3SmallTag */.vb, {
      "data-test-id": "SafenSecureTravCrd-H3SmallTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      fontWeight: "black",
      fontSize: "large",
      margin: device == "sm" ? "" : "0 0 12px",
      "data-test-id": "SafenSecureTravCrd-ParaTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatList, {
      cardQuantity: cardQuantity,
      "data-test-id": "SafenSecureTravCrd-FeatList",
      children: featList && featList?.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          "data-test-id": `SafenSecureTravCrd-${index}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: item,
            "data-test-id": "SafenSecureTravCrd-FormattedText"
          })
        }, index);
      })
    }), poweredBy && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      margin: "auto 0 0",
      gap: "20px",
      alignItems: "Center",
      "data-test-id": "SafenSecureTravCrd-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xs",
        "data-test-id": "SafenSecureTravCrd-SpanTag",
        children: "Powered By"
      }), poweredBy && poweredBy.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
          src: item,
          height: "32px",
          width: "auto",
          "data-test-id": `SafenSecureTravCrd-ImageComponent-${index}`
        }, index);
      })]
    }), cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
      width: device == "lg" ? "92px" : "54px",
      height: device == "lg" ? "102px" : "60px",
      src: cardImg,
      "data-test-id": "SafenSecureTravCrd-ImageComponent"
    })]
  });
};

/* harmony default export */ const SafenSecureTrav_SafenSecureTravCrd = (SafenSecureTravCrd);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTrav.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








const SafenSecureTrav = ({
  title,
  data
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravStyle, {
    "data-test-id": "SafenSecureTrav-SafenSecureTravStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureBgWrap, {
      "data-test-id": "SafenSecureTrav-SafenSecureBgWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
        width: "100%",
        height: "558px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/safen_Secure_Bg_200cfd8d5c.svg",
        "data-test-id": "SafenSecureTrav-ImageComponent"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(src/* InnerContentWrap */.IY, {
      "data-test-id": "SafenSecureTrav-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
        margin: "0 0 60px",
        "data-test-id": "SafenSecureTrav-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        margin: "0 0 20px",
        "data-test-id": "SafenSecureTrav-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? "60px" : "20px",
        flexDirection: device == "sm" ? "column" : "row",
        flexWrap: "wrap",
        "data-test-id": "SafenSecureTrav-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureTrav_SafenSecureTravCrd, _objectSpread(_objectSpread({
            cardQuantity: data?.length
          }, item), {}, {
            "data-test-id": `SafenSecureTrav-SafenSecureTravCrd-${index}`
          }), index);
        })
      })]
    })]
  });
};

/* harmony default export */ const SafenSecureTrav_SafenSecureTrav = (SafenSecureTrav);

/***/ }),

/***/ 8431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SecureTravOffer_SecureTravOffer)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SecureTravOffer/SecureTravOffer.style.ts



const SecureTravOfferStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravOfferStyle",
  componentId: "sc-19r9m5r-0"
})(["display:flex;flex-direction:column;gap:24px;svg{flex-shrink:0;}", "{font-size:22px;font-weight:900;}"], components/* H5TagStyle */.Wl);
const SecureTravItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravItem",
  componentId: "sc-19r9m5r-1"
})(["display:flex;gap:24px;@media ", "{gap:8px;}"], isomorphic_utils_src.deviceType.mobile);
const SecureTravImgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravImgWrap",
  componentId: "sc-19r9m5r-2"
})(["background:linear-gradient( 125.09deg,#474747 0%,rgba(255,255,255,0) 64.55% );border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:72px;height:80px;", ""], p => p.pageTheme === isomorphic_utils_src.PARTNER.MMT ? `
     background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);
    ` : p.pageTheme === isomorphic_utils_src.PARTNER.GI ? `background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);` : `
    `);
const SecureTravContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravContent",
  componentId: "sc-19r9m5r-3"
})(["align-self:center;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SecureTravOffer/SecureTravOffer.tsx








const SecureTravOffer = ({
  data
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravOfferStyle, {
    "data-test-id": "SecureTravOffer-SecureTravOfferStyle",
    children: data && data.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravItem, {
        "data-test-id": `SecureTravOffer-SecureTravItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravImgWrap, {
          pageTheme: context ? context : undefined,
          "data-test-id": "SecureTravOffer-SecureTravImgWrap",
          children: item.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "48px",
            height: "48px",
            src: item.travImg,
            loading: "eager",
            "data-test-id": "SecureTravOffer-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravContent, {
          "data-test-id": "SecureTravOffer-SecureTravContent",
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-H5Tag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "md",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }), item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            margin: device == "lg" ? "16px 0 0" : "8px 0 0",
            fontSize: device == "lg" ? "sm" : "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.info,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ const SecureTravOffer_SecureTravOffer = (SecureTravOffer);

/***/ }),

/***/ 13841:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SelectCountryModal_CountryList)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 4 modules
var utils = __webpack_require__(64264);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-window/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__(88475);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/CountryList.style.tsx

const ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CountryListstyle__ArrowButtonWrap",
  componentId: "jzswvv-0"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const DescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__DescriptionWrap",
  componentId: "jzswvv-1"
})(["cursor:none;margin:10px 0px 0px 32px;border-radius:4px;padding:10px 6px 10px 10px;background-color:#f6f6f6;cursor:", ";"], props => props.isCursorPointer ? "pointer" : "default");
const ColumnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__ColumnWrapper",
  componentId: "jzswvv-2"
})(["display:flex;flex-direction:column;& > span{margin-bottom:-6px;}"]);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.style.ts
var SelectCountryModal_style = __webpack_require__(87906);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/CountryList.tsx










const CountryList = ({
  countryData,
  countryHandler,
  isCheckedHandler,
  setCountryData,
  searchQueryHighlighter,
  setIsSelectedError,
  showHeader,
  setCountrySelectToastMsg
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const windowWidth = window.innerWidth - 60; //TODO: handle default cell height using css var

  const defaultCellHeight = 57; //TODO: Check alternate height calculation using DOM elements

  const windowHeight = window.innerHeight - 213;
  const listRef = (0,react.useRef)(null);
  const {
    0: showViewAllButton,
    1: setShowViewAllButton
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const temp = countryData.map(data => {
      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  }, []);
  (0,react.useEffect)(() => {
    listRef?.current?.resetAfterIndex(0);
  }, [countryData]);

  const handleDescription = code => {
    const data = countryData.filter(data => data?.code === code)[0];

    if (data.showExpandedDescription || data.description.length < 80) {
      setShowViewAllButton(false);
      console.log(data.description.length);
      return data.description;
    }

    setShowViewAllButton(true);
    const tempDescData = data.description.substring(0, 80).split(" ");
    tempDescData.pop();
    const descData = tempDescData.join(" ") + "...";
    return descData;
  };

  const handleRegionDescription = code => {
    let temp = countryData.map(data => {
      if (data.code === code && !data.showDescription) {
        data["showDescription"] = true;
        data["showExpandedDescription"] = false;
        return data;
      }

      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  };

  const handleErrorToast = (0,utils/* debounce */.Ds)(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelectError = country => {
    const isExclusiveCountrySelected = countryData.find(item => item.isExclusiveSelection && item.isSelected);

    if (isExclusiveCountrySelected && !country?.isExclusiveSelection && country.isDisabled) {
      setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
      handleErrorToast();
    } else if (country?.isExclusiveSelection && !isExclusiveCountrySelected && country.isDisabled) {
      setCountrySelectToastMsg("India cannot be chosen for International Travel");
      handleErrorToast();
    } else if (country.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      {
        !country.isSelected && !country.showDescription && handleRegionDescription(country.code);
      }
      {
        country.isSelected && country.showDescription && handleRegionDescription(country.code);
      }
      countryHandler(country.code);
    }
  };

  const handleViewAll = code => {
    let temp = countryData.map(data => {
      if (data.code === code) {
        data["showExpandedDescription"] = !data["showExpandedDescription"];
      }

      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  };

  const rowRenderer = ({
    index,
    key
  }) => {
    const item = countryData?.[index];

    if (!item) {
      return null; // Return null if item is undefined
    } else if (item.type === "HEADER") {
      return showHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_style/* CountryItem */.wh, {
        disableCursor: true,
        margin: device === "lg" ? "0px 17px 0px 0px" : "",
        "data-test-id": "CountryList-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: item.name,
          baseStyle: {
            fontWeight: "bold",
            fontSize: "14px"
          },
          "data-test-id": "CountryList-rowRenderer-FormattedText"
        })
      });
    } else if (item.code) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-test-id": `CountryList-rowRenderer-${key}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountryModal_style/* CountryItem */.wh, {
          disableCursor: true,
          margin: device === "lg" ? "0px 17px 0px 0px" : "",
          "data-test-id": "CountryList-rowRenderer-CountryItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            "data-test-id": "CountryList-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* CheckButton */.nt, {
              handleChange: () => handleCountrySelectError(item),
              isChecked: item.isDisabled ? true : isCheckedHandler(item),
              isDisabled: item.isDisabled,
              "data-test-id": "CountryList-rowRenderer-CheckButton",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                handleClick: () => handleCountrySelectError(item),
                alignItems: "center",
                justifyContent: "space-between",
                "data-test-id": "CountryList-rowRenderer-FlexComp",
                children: [item.subtitle ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ColumnWrapper, {
                  "data-test-id": "CountryList-rowRenderer-ColumnWrapper",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: searchQueryHighlighter(item.name)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.subtitle,
                      baseStyle: {
                        fontSize: "12px",
                        fontWeight: "400"
                      },
                      "data-test-id": "CountryList-rowRenderer-FormattedText"
                    })
                  })]
                }) : searchQueryHighlighter(item.name), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item.countryCount,
                  baseStyle: {
                    padding: "0px 10px 0px 0px",
                    fontSize: "12px",
                    color: "#4A4A4A"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item.regionName,
                  baseStyle: {
                    fontSize: "12px",
                    color: "#0000004D"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                })]
              })
            }), item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
              onClick: () => {
                handleRegionDescription(item.code);
              },
              "data-test-id": "CountryList-rowRenderer-ArrowButtonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                width: "9px",
                height: "9px",
                margin: "0px 0px 0px 0px",
                src: item.showDescription ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                "data-test-id": "CountryList-rowRenderer-ImageComponent"
              })
            })]
          }), item.showDescription && item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrap, {
            "data-test-id": "CountryList-rowRenderer-DescriptionWrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.descTitle,
              baseStyle: {
                fontWeight: "bold",
                fontSize: "14px"
              },
              "data-test-id": "CountryList-rowRenderer-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: handleDescription(item.code),
                baseStyle: {
                  fontSize: "14px"
                },
                "data-test-id": "CountryList-rowRenderer-FormattedText"
              })
            }), showViewAllButton && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
              handleClick: () => {
                handleViewAll(item.code);
              },
              fontWeight: "bold",
              "data-test-id": "CountryList-rowRenderer-AnchorTag",
              children: "View All"
            })]
          })]
        })
      }, key);
    }

    return;
  };

  const getItemSize = (code, isShowDesc, isShowAllDesc) => {
    let expansionValue = 0;

    if (isShowAllDesc) {
      expansionValue = 2;
    } else if (isShowDesc) {
      expansionValue = 1;
    }

    return (0,utils/* interpolateRowHeight */.IS)(device === "lg" ? 360 : windowWidth, code, expansionValue) || defaultCellHeight;
  };

  const getItemSizes = index => {
    const height = countryData[index].type === "REGION" ? getItemSize(countryData[index].code, countryData[index].showDescription, countryData[index].showExpandedDescription) : defaultCellHeight;
    return height;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* VariableSizeList */.S_, {
    height: device === "lg" ? 380 : windowHeight,
    itemCount: countryData.length,
    itemSize: getItemSizes,
    width: device === "lg" ? 360 : windowWidth,
    ref: listRef,
    "data-test-id": "CountryList-FixList",
    children: ({
      index,
      style
    }) => {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: style,
        "data-test-id": `CountryList-${index}`,
        children: rowRenderer({
          index,
          key: index
        })
      }, index);
    }
  });
};

/* harmony default export */ const SelectCountryModal_CountryList = (CountryList);

/***/ }),

/***/ 79607:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_virtualized__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37863);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87109);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54927);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42874);
/* harmony import */ var _SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87906);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52322);









const SelectCountryCodeModal = ({
  countryData,
  handleSelectCountry,
  handleClose
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointV2 */ .bU)();
  const windowWidth = window.innerWidth - 60;
  const {
    0: countriesData,
    1: setCountriesData
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(countryData);
  const {
    0: searchTxt,
    1: setInputValue
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const rowHeight = 60;

  const calculateListHeight = () => {
    const rowCount = countriesData?.length ?? 0; // Replace with your actual data length

    const height = rowCount * rowHeight;
    return height;
  };

  const countryHandler = id => {
    if (id) {
      setCountriesData(countryData?.map(item => {
        if (id === item.id) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      }));
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (searchTxt?.length) {
      const filteredDataList = searchTxt ? countryData?.filter(items => items.countryName?.toLowerCase().includes(searchTxt.toLowerCase())) : countryData;
      setCountriesData(filteredDataList);
    }
  }, [searchTxt]);

  const rowRenderer = ({
    index,
    key
  }) => {
    const item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      "data-test-id": `SelectCountryCodeModal-rowRenderer-${key}`,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_5__/* .CountryItem */ .wh, {
        onClick: () => countryHandler(item.id),
        "data-test-id": "SelectCountryCodeModal-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .RadioButton */ .EU, {
          handleChange: () => countryHandler(item.id),
          activeBtn: item.isSelected,
          "data-test-id": "SelectCountryCodeModal-rowRenderer-RadioButton",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .FlexComp */ .bA, {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .FlexComp */ .bA, {
              alignItems: "center",
              gap: "8px",
              "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
              children: [item.countryFlag && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .ImageComponent */ .cu, {
                src: item.countryFlag,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-ImageComponent"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .SpanTag */ .pF, {
                fontSize: "sm",
                color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.blackText */ .rS.blackText,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
                children: item.countryName
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .SpanTag */ .pF, {
              fontWeight: "bold",
              fontSize: "xs",
              color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.blackText */ .rS.blackText,
              "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
              children: item.countryCode
            })]
          })
        })
      })
    }, key);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .CommonModalDweb */ .Eq, {
    handleClick: handleClose,
    customTitle: "Select Country",
    "data-test-id": "SelectCountryCodeModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .TMFloatingInput */ .Wz, {
      handleChange: e => setInputValue(e.target.value),
      inputValue: searchTxt,
      labelTxt: "Search Country Name",
      "data-test-id": "SelectCountryCodeModal-TMFloatingInput"
    }), countriesData?.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_5__/* .CountrySection */ .AK, {
      "data-test-id": "SelectCountryCodeModal-CountrySection",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .SpanTag */ .pF, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Country Name"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .SpanTag */ .pF, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Code"
      })]
    }), countriesData && countriesData?.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_virtualized__WEBPACK_IMPORTED_MODULE_1__/* .List */ .aV, {
      width: device === "lg" ? 360 : windowWidth,
      height: calculateListHeight(),
      style: {
        minHeight: calculateListHeight()
      },
      autoHeight: true,
      rowHeight: rowHeight,
      rowCount: countriesData.length,
      rowRenderer: rowRenderer,
      "data-test-id": "SelectCountryCodeModal-List"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .ParaTag */ .dZ, {
      fontSize: "sm",
      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
      margin: "16px 0 16px",
      "data-test-id": "SelectCountryCodeModal-ParaTag",
      children: "No Country Found! Please enter correct name"
    }), countriesData?.length != 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_5__/* .BtnWrap */ .Kj, {
      "data-test-id": "SelectCountryCodeModal-BtnWrap",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_3__/* .LandingButton */ .WB, {
        customWidth: "100%",
        customTitle: "Select",
        onClick: () => handleSelectCountry(countriesData),
        "data-test-id": "SelectCountryCodeModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SelectCountryCodeModal);

/***/ }),

/***/ 87906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": () => (/* binding */ CountrySection),
/* harmony export */   "Kj": () => (/* binding */ BtnWrap),
/* harmony export */   "NQ": () => (/* binding */ SelectCountrySheetStyle),
/* harmony export */   "pg": () => (/* binding */ CountrySectionWrap),
/* harmony export */   "v0": () => (/* binding */ SelectCountryHeader),
/* harmony export */   "wh": () => (/* binding */ CountryItem)
/* harmony export */ });
/* unused harmony exports SelectCountryModalStyle, PopularRegionCountries */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54927);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);




const SelectCountryModalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .CommonModalDwebStyle */ .E5).withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryModalStyle",
  componentId: "sc-1n427kc-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
const CountryItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountryItem",
  componentId: "sc-1n427kc-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;margin:", ";cursor:", ";", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], props => props.margin && `${props.margin}`, props => props.disableCursor ? "default" : "pointer", _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .LandingButtonStyle */ .zm, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .CheckButtonStyle */ .mT, _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.yellowText3 */ .rS.yellowText3, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .ToolTipCompWrapper */ .V6);
const BtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__BtnWrap",
  componentId: "sc-1n427kc-2"
})(["position:", ";", ";", ";width:100%;"], props => props.position ? `${props.position}` : `sticky`, props => props.bottom && `bottom:${props.bottom}`, props => props.background && `background:${props.background}`);
const CountrySection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySection",
  componentId: "sc-1n427kc-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
const CountrySectionWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySectionWrap",
  componentId: "sc-1n427kc-4"
})(["@media ", "{padding:16px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const PopularRegionCountries = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__PopularRegionCountries",
  componentId: "sc-1n427kc-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
const SelectCountrySheetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountrySheetStyle",
  componentId: "sc-1n427kc-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .TMInputWrap */ .dd);
const SelectCountryHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryHeader",
  componentId: "sc-1n427kc-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);

/***/ }),

/***/ 57593:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SelectCountryModal_SelectCountryModal)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/fuse.js/dist/fuse.mjs
var fuse = __webpack_require__(89325);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 4 modules
var utils = __webpack_require__(64264);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionCountryModal.style.tsx



const modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalDwebStyle",
  componentId: "n7dugx-0"
})(["position:fixed;width:", ";height:", ";max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", p => p.customHeight ? p.customHeight : "420px", components/* SectionDividersStyle */.$f, components/* TMInputWrap */.dd, src.deviceType.mobile, modalAnim, components/* TMInputWrap */.dd);
const CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalHeader",
  componentId: "n7dugx-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:85%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], components/* H5TagStyle */.Wl, p => p.nonClipHeading && `
     ${components/* H5TagStyle */.Wl} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, src.deviceType.mobile);
const CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CrossIconWrap",
  componentId: "n7dugx-2"
})(["flex-shrink:0;cursor:pointer;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionCountryModal.tsx







const RegionCountryModal = ({
  children,
  customTitle,
  customSubTitle,
  handleClick,
  customWidth,
  customIcon,
  errorModal,
  customHeight,
  nonClipHeading
}) => {
  (0,react.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
    return () => {};
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ReactPortalComp */.hK, {
    "data-test-id": "RegionCountryModal-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customHeight: customHeight,
      customWidth: customWidth,
      "data-test-id": "RegionCountryModal-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionCountryModal-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
            "data-test-id": "RegionCountryModal-H5Tag",
            children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "40px",
              height: "40px",
              src: customIcon,
              "data-test-id": "RegionCountryModal-ImageComponent"
            }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customTitle,
              "data-test-id": "RegionCountryModal-FormattedText"
            })]
          }), customSubTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: customSubTitle,
            "data-test-id": "RegionCountryModal-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
          onClick: handleClick,
          "data-test-id": "RegionCountryModal-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "RegionCountryModal-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* BackDropComp */.YP, {
      onClose: handleClick,
      "data-test-id": "RegionCountryModal-BackDropComp"
    })]
  });
};

/* harmony default export */ const RegionModalDweb_RegionCountryModal = (RegionCountryModal);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/CountryList.tsx + 1 modules
var CountryList = __webpack_require__(13841);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.style.ts
var SelectCountryModal_style = __webpack_require__(87906);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const analytics = (0,insurance/* getAnalytics */.I)();
const DEBOUNCE_TIME = 300;

const fuzzySearch = (searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) => {
  const selectedCountriesData = displayCountryData.filter(country => country.isSelected && !country.isDisabled);
  const searchResults = searcher.search(searchValue);
  const filteredData = searchResults?.map(match => match?.item);
  const originalSortData = countryData.map(country => {
    return displayCountryData.find(item => item.code === country.code);
  });
  const allObjects = [...selectedCountriesData, ...filteredData, ...originalSortData];
  const tempObj = allObjects.reduce((acc, obj) => {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  const uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

const debouncedSearch = (0,utils/* debounce */.Ds)(fuzzySearch, DEBOUNCE_TIME);

const SelectCountryModal = ({
  handleSelectCountry,
  countryData,
  setShowCountry,
  showCountry,
  setCountryData,
  countrySelectErrMsg,
  setIsCountryError,
  popularCountries,
  setPopularCountries,
  customSubTitle,
  handleDescriptionModal
}) => {
  const {
    0: displayCountryData,
    1: setDisplayCountrysData
  } = (0,react.useState)(countryData);
  const {
    0: searchTxt,
    1: setSearchTxt
  } = (0,react.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react.useState)("");
  const searchedCountriesOmn = (0,react.useRef)([]);
  const selectedCountriesOmn = (0,react.useRef)([]);
  const searcher = new fuse/* default */.Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  const noSearchResults = addTimeOut => {
    let allObjects = [];
    const selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    const selectedCountriesData = displayCountryData.filter(country => {
      return country.isSelected && !country.isDisabled;
    });
    const originalSortData = countryData.map(country => {
      return displayCountryData.find(item => item.code === country.code);
    });

    if (selectedCountriesData.length) {
      allObjects = [_objectSpread({}, selectedHeader), ...selectedCountriesData, ...originalSortData];
      const tempObj = allObjects.reduce((acc, obj) => {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      const uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(uniqueObjects);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(originalSortData);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(() => {
    noSearchResults(false);
  }, []);

  const countryClickHandler = code => {
    handleDescriptionModal(displayCountryData.filter(data => data.code === code)[0]);
    let updatedCountryArr = displayCountryData?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return _objectSpread({}, country);
        }
        /* istanbul ignore next */


        if (selectedCountriesOmn?.current?.length >= 30) {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current?.slice(1), country.code];
        } else {
          selectedCountriesOmn.current = [...selectedCountriesOmn.current, country.code];
        }

        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return _objectSpread(_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = updatedCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    updatedCountryArr = updatedCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        }) : _objectSpread({}, country);
      }

      return _objectSpread({}, country);
    });
    const selectedCountryCodes = updatedCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedCountryCodes.map(item => {
      updatedCountryArr = updatedCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return _objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    const popularCountryData = updatedCountryArr.filter(country => country.isSelected || country.isPopular);
    setPopularCountries([...popularCountryData.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)]);
  };

  const handleSearchtxt = (0,react.useCallback)(searchValue => {
    debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  const onSearchChange = searchValue => {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  const searchQueryHighlighter = ele => {
    const withSpecialCharsSupport = searchTxt?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const searchRegex = new RegExp(`(${withSpecialCharsSupport})`, "ig");
    const highlighted = ele.replace(searchRegex, match => `<span class="highlight">${match}</span>`);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModal-searchQueryHighlighter-ParaTag"
    });
  };

  const isCheckedHandler = (0,react.useCallback)(data => {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  const handleCrossClick = () => {
    setPopularCountries(showCountry);

    if (searchedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    let tempCountryData = displayCountryData.map(country => {
      return _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(data => {
      tempCountryData = tempCountryData.map(country => {
        if (data.code === country.code) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return _objectSpread({}, country);
      });
    });
    setDisplayCountrysData(_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  const onCountrySubmit = () => {
    setIsCountryError(false);

    if (searchedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn?.current?.join("|")
      } //"click"
      );
      selectedCountriesOmn.current = [];
    }

    let countryDataArr = countryData.map(country => {
      return _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(data => {
      countryDataArr = countryDataArr.map(country => {
        if (country.code === data.code) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return _objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    const selectedCountryCodes = displayCountryData.filter(item => item.isSelected && !item.isDisabled).map(item => item.code);
    (0,utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    const selectedNonPopCountries = displayCountryData.filter(data => data.isSelected && !data.isPopular);
    analytics?.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(c => c.name).join("|")
    } //"click"
    );
    handleSelectCountry && handleSelectCountry();
  };

  const handleSearchTxt = event => {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      if (searchedCountriesOmn?.current?.length >= 30) {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current?.slice(1), searchTxt];
      } else {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current, searchTxt];
      }
    }

    setSearchTxt(_ => event.target.value);
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RegionModalDweb_RegionCountryModal, {
    customHeight: "600px",
    handleClick: onCountrySubmit,
    customTitle: "Select Destinations",
    customSubTitle: customSubTitle,
    "data-test-id": "SelectCountryModal-RegionCountryModal",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TMFloatingInput */.Wz, {
      handleChange: e => handleSearchTxt(e),
      inputValue: searchTxt,
      labelTxt: "Search Country/Region",
      "data-test-id": "SelectCountryModal-TMFloatingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_style/* CountrySectionWrap */.pg, {
      "data-test-id": "SelectCountryModal-CountrySectionWrap",
      children: displayCountryData?.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList/* default */.Z, {
        countryData: searchTxt.length ? displayCountryData.filter(country => country.type !== "HEADER") : displayCountryData,
        countryHandler: countryClickHandler,
        isCheckedHandler: isCheckedHandler,
        searchQueryHighlighter: searchQueryHighlighter,
        setCountryData: setDisplayCountrysData,
        setIsSelectedError: setIsSelectedError,
        showHeader: !searchTxt.length,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        "data-test-id": "SelectCountryModal-CountryList"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        fontSize: "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "30px 0px 0px 0px",
        "data-test-id": "SelectCountryModal-ParaTag",
        children: "No Country Found! Please enter correct name"
      })
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectToastMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), displayCountryData?.length && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_style/* BtnWrap */.Kj, {
      "data-test-id": "SelectCountryModal-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        margin: "16px 0px 0px 0px",
        customWidth: "100%",
        customTitle: "Add Destination",
        onClick: onCountrySubmit,
        "data-test-id": "SelectCountryModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ const SelectCountryModal_SelectCountryModal = (SelectCountryModal);

/***/ }),

/***/ 79377:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var fuse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89325);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2182);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64264);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54927);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42874);
/* harmony import */ var _CountryList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13841);
/* harmony import */ var _SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87906);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_3__/* .getAnalytics */ .I)();
const DEBOUNCE_TIME = 300;

const fuzzySearch = (searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) => {
  const selectedCountriesData = displayCountryData.filter(country => country.isSelected && !country.isDisabled);
  const searchResults = searcher.search(searchValue);
  const filteredData = searchResults?.map(match => match?.item);
  const originalSortData = countryData.map(country => {
    return displayCountryData.find(item => item.code === country.code);
  });
  const allObjects = [...selectedCountriesData, ...filteredData, ...originalSortData];
  const tempObj = allObjects.reduce((acc, obj) => {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  const uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

const debouncedSearch = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .debounce */ .Ds)(fuzzySearch, 300);

const SelectCountryModalSheet = ({
  handleSelectCountry,
  countryData,
  setShowCountry,
  setCountryData,
  showCountry,
  countrySelectErrMsg,
  setIsCountryError,
  popularCountries,
  setPopularCountries,
  handleDescriptionModal,
  customSubTitle
}) => {
  const {
    0: displayCountryData,
    1: setDisplayCountrysData
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(countryData);
  const {
    0: searchTxt,
    1: setSearchTxt
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const searchedCountriesOmn = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)([]);
  const selectedCountriesOmn = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)([]);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
  const searcher = new fuse_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  const noSearchResults = addTimeOut => {
    let allObjects = [];
    const selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    const selectedCountriesData = displayCountryData.filter(country => {
      return country.isSelected && !country.isDisabled;
    });
    const originalSortData = countryData.map(country => {
      return displayCountryData.find(item => item.code === country.code);
    });

    if (selectedCountriesData.length) {
      allObjects = [_objectSpread({}, selectedHeader), ...selectedCountriesData, ...originalSortData];
      const tempObj = allObjects.reduce((acc, obj) => {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      const uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(uniqueObjects);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(originalSortData);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    noSearchResults(false);
  }, []);

  const countryClickHandler = code => {
    handleDescriptionModal(displayCountryData.filter(data => data.code === code)[0]);
    let updatedCountryArr = displayCountryData?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return _objectSpread({}, country);
        }
        /* istanbul ignore next */


        if (selectedCountriesOmn?.current?.length >= 30) {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current?.slice(1), country.code];
        } else {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current, country.code];
        }

        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return _objectSpread(_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = updatedCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    updatedCountryArr = updatedCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        }) : _objectSpread({}, country);
      }

      return _objectSpread({}, country);
    });
    const selectedCountryCodes = updatedCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedCountryCodes.map(item => {
      updatedCountryArr = updatedCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return _objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    const popularCountryData = updatedCountryArr.filter(country => country.isSelected || country.isPopular);
    setPopularCountries([...popularCountryData.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)]);
  };

  const handleSearchtxt = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(searchValue => {
    debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  const onSearchChange = searchValue => {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  const searchQueryHighlighter = ele => {
    const withSpecialCharsSupport = searchTxt?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const searchRegex = new RegExp(`(${withSpecialCharsSupport})`, "ig");
    const highlighted = ele.replace(searchRegex, match => `<span class="highlight">${match}</span>`);
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .ParaTag */ .dZ, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModalSheet-searchQueryHighlighter-ParaTag"
    });
  };

  const isCheckedHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(data => {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  const handleCrossClick = () => {
    setPopularCountries(showCountry);

    if (searchedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    let tempCountryData = displayCountryData.map(country => {
      return _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(data => {
      tempCountryData = tempCountryData.map(country => {
        if (data.code === country.code) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return _objectSpread({}, country);
      });
    });
    setDisplayCountrysData(_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  const onCountrySubmit = () => {
    setIsCountryError(false);

    if (searchedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn?.current?.join("|")
      } //"click"
      );
      selectedCountriesOmn.current = [];
    }

    let countryDataArr = countryData.map(country => {
      return _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(data => {
      countryDataArr = countryDataArr.map(country => {
        if (country.code === data.code) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return _objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    const selectedCountryCodes = displayCountryData.filter(item => item.isSelected && !item.isDisabled).map(item => item.code);
    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .replaceHistoryRemoveParams */ ._A)("countries");
    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .replaceHistory */ .df)("countries", selectedCountryCodes.join(","));
    const selectedNonPopCountries = displayCountryData.filter(data => data.isSelected && !data.isPopular);
    analytics?.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(c => c.name).join("|")
    } //"click"
    );
    handleSelectCountry && handleSelectCountry();
  };

  const handleSearchTxt = event => {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      if (searchedCountriesOmn?.current?.length >= 30) {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current?.slice(1), searchTxt];
      } else {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current, searchTxt];
      }
    }

    setSearchTxt(_ => event.target.value);
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .ReactPortalComp */ .hK, {
    "data-test-id": "SelectCountryModalSheet-ReactPortalComp",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_8__/* .SelectCountrySheetStyle */ .NQ, {
      "data-test-id": "SelectCountryModalSheet-SelectCountrySheetStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_8__/* .SelectCountryHeader */ .v0, {
        "data-test-id": "SelectCountryModalSheet-SelectCountryHeader",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .AnchorTag */ .Y6, {
          handleClick: handleCrossClick,
          "data-test-id": "SelectCountryModalSheet-AnchorTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("path", {
              d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
              fill: "#808080"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .FlexComp */ .bA, {
          flexDirection: "column",
          "data-test-id": "SelectCountryModalSheet-FlexComp",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .ParaTag */ .dZ, {
            fontSize: "md",
            fontWeight: "bold",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "SelectCountryModalSheet-ParaTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .FormattedText */ .rc, {
              value: "Select Destinations",
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .SpanTag */ .pF, {
            fontSize: "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greyText6 */ .rS.greyText6,
            "data-test-id": "SelectCountryModalSheet-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .FormattedText */ .rc, {
              value: customSubTitle,
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .TMFloatingInput */ .Wz, {
        handleChange: e => handleSearchTxt(e),
        inputValue: searchTxt,
        labelTxt: "Search Country/Region",
        "data-test-id": "SelectCountryModalSheet-TMFloatingInput"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_8__/* .CountrySectionWrap */ .pg, {
        "data-test-id": "SelectCountryModalSheet-CountrySectionWrap",
        children: displayCountryData?.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_CountryList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          countryData: searchTxt.length ? displayCountryData.filter(country => country.type !== "HEADER") : displayCountryData,
          countryHandler: countryClickHandler,
          isCheckedHandler: isCheckedHandler,
          searchQueryHighlighter: searchQueryHighlighter,
          setCountryData: setDisplayCountrysData,
          setIsSelectedError: setIsSelectedError,
          showHeader: !searchTxt.length,
          setCountrySelectToastMsg: setCountrySelectToastMsg,
          "data-test-id": "SelectCountryModalSheet-CountryList"
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .ParaTag */ .dZ, {
          fontSize: "sm",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greyText */ .rS.greyText,
          margin: "30px 0px 0px 0px",
          "data-test-id": "SelectCountryModalSheet-ParaTag",
          children: "No Country Found! Please enter correct name"
        })
      }), isSelectedError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .WebToast */ .Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "75px",
        "data-test-id": "SelectCountryModalSheet-WebToast"
      }), displayCountryData?.length && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_SelectCountryModal_style__WEBPACK_IMPORTED_MODULE_8__/* .BtnWrap */ .Kj, {
        position: "fixed",
        bottom: "0px",
        background: "white",
        "data-test-id": "SelectCountryModalSheet-BtnWrap",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_5__/* .LandingButton */ .WB, {
          margin: "12px 16px 12px 16px",
          customWidth: "92%",
          customTitle: "Add Destination",
          onClick: onCountrySubmit,
          "data-test-id": "SelectCountryModalSheet-LandingButton"
        })
      })]
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SelectCountryModalSheet);

/***/ })

}]);